import styled from 'styled-components';

export const LoaderContainer = styled.div`
  position: relative;

  .line {
    margin-bottom: 15px;
  }
`;

export const Transparence = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
  background: ${({ theme }) =>
    `linear-gradient(transparent, ${theme.colors.semantic.surface.card})`};
`;
